import React, { useState, useEffect } from "react";
import EmployeeModal from "../utils/employeemodal";
import EmployeeDayModal from "../utils/employeedaymodal";
import { CircularProgress, Box } from "@mui/material";
import PtoModal from "./PtoModal";
import dayjs from "dayjs";
import GenerateReportModal from "./generatereportmodal";
import { isUnverifiedDay, tableDaySeconds, unverifiedDayCount } from "./reportHours";

const UNVERIFIED_TITLE = "An automatic clock-out on this day is waiting for its correction and is not counted yet.";

// approvedOnly (the plain "All" view): hours from recap approved_hours (owner 10-19: reports count
// approved data; an automatic clock-out counts once its correction is approved). A status filter shows
// that status's hours as before.
const RecapTable = ({ data, loading, dateRange, searchTerm, approvedOnly = false }) => {
  // const [currentPage, setCurrentPage] = useState(1);
  // const [rowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedPtoEmployee, setSelectedPtoEmployee] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);
// useEffect(() => {
//   if (data && data.length > 0) {
//     const mapped = data.map((emp) => {
//       // create empty week
// const weekHours = {
//   Mon: "-",
//   Tue: "-",
//   Wed: "-",
//   Thu: "-",
//   Fri: "-",
//   Sat: "-",
//   Sun: "-"
// };

//    emp.recap?.forEach((r) => {
//   const day = dayjs(r.date).format("ddd");

//   if (weekHours[day] !== undefined) {
//     const time = r.total_hours || "0:00:00";
//     weekHours[day] = time.split(":").slice(0, 2).join(":");
//   }
// });

//       return {
//         id: emp.emp_id,
//         name: emp.employee_name,
//         type: emp.employee_type,
//         hireDate: emp.hire_date || "N/A",
//         totalDays: emp.total_days_in_period,
//         daysAbsent: emp.days_absent,
//         pto: Number(emp.pto_days) || 0,
//      totalHours: emp.total_hours_for_period
//   ? emp.total_hours_for_period.split(":").slice(0,2).join(":")
//   : "0:00",
//         role: emp.employee_type === "Hourly" ? "Employee" : "Staff",
//         recap: emp.recap,
//         weekHours,   // 👈 important
//       };
//     });

//     setTableData(mapped);
//   }
// }, [data]);
  // ⏳ Initialize and map API data
  // useEffect(() => {
  //   if (data && data.length > 0) {
  //     const mapped = data.map((emp) => ({
  //       id: emp.emp_id,
  //       name: emp.employee_name,
  //       type: emp.employee_type,
  //       hireDate: emp.hire_date || "N/A",
  //       totalDays: emp.total_days_in_period,
  //       daysAbsent: emp.days_absent,
  //    pto: Number(emp.pto) || 0,
  //       totalHours: emp.total_hours_for_period,
  //       role: emp.employee_type === "Hourly" ? "Employee" : "Staff",
  //       recap: emp.recap,
  //       absent_dates: emp.absent_dates,
  //     }));
  //     setTableData(mapped);
  //   }
  // }, [data]);
useEffect(() => {
  if (!data || data.length === 0) {
    setTableData([]);
    return;
  }

  // const start = dayjs(dateRange.startDate);
  // const end = dayjs(dateRange.endDate);

  // const dayDiff = end.diff(start, "day") + 1;

  // let rangeStart;
  // let rangeEnd;

  // // ✅ If range <= 7 days → use exact selected range
  // if (dayDiff <= 7) {
  //   rangeStart = start;
  //   rangeEnd = end;
  // } else {
  //   // ✅ If range > 7 days → show last week only
  //   rangeStart = end.startOf("week").add(1, "day"); // Monday
  //   rangeEnd = rangeStart.add(6, "day"); // Sunday
  // }

const start = dayjs(dateRange.startDate).startOf("day");
const end = dayjs(dateRange.endDate).startOf("day");

const dayDiff = end.diff(start, "day") + 1;

let rangeStart;
let rangeEnd;

if (dayDiff <= 7) {
  // ✅ Use exact selected range for 7 days or less
  rangeStart = start;
  rangeEnd = end;
} else {
  // ✅ For more than 7 days → use last 7 days ending at endDate
  rangeEnd = end;
  rangeStart = end.subtract(6, "day");
}

console.log("📅 rangeStart:", rangeStart.format("YYYY-MM-DD"));
console.log("📅 rangeEnd:", rangeEnd.format("YYYY-MM-DD"));

// const mapped = data.map((emp) => {
//   const weekHours = {
//     Mon: "0:00",
//     Tue: "0:00",
//     Wed: "0:00",
//     Thu: "0:00",
//     Fri: "0:00",
//     Sat: "0:00",
//     Sun: "0:00",
//   };

//   let totalSeconds = 0; // ✅ NEW

//   // emp.recap?.forEach((r) => {
//   //   const recordDate = dayjs(r.date);

//   //   if (
//   //     recordDate.isSame(rangeStart, "day") ||
//   //     (recordDate.isAfter(rangeStart) &&
//   //       recordDate.isBefore(rangeEnd)) ||
//   //     recordDate.isSame(rangeEnd, "day")
//   //   ) {
//   //     const day = recordDate.format("ddd");

//   //     if (weekHours[day] !== undefined) {
//   //       const time = r.total_hours || "0:00:00";

//   //       weekHours[day] = time.split(":").slice(0, 2).join(":");

//   //       // ✅ accumulate correct total
//   //       const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
//   //       totalSeconds += h * 3600 + m * 60 + s;
//   //     }
//   //   }
//   // });

// // emp.recap?.forEach((r) => {
// //     const recordDate = dayjs(r.date).startOf("day");
// //     const rStart = rangeStart.startOf("day");
// //     const rEnd = rangeEnd.startOf("day");

// //     const isInRange =
// //       (recordDate.isSame(rStart) || recordDate.isAfter(rStart)) &&
// //       (recordDate.isSame(rEnd) || recordDate.isBefore(rEnd));

// //     if (isInRange) {
// //       const day = recordDate.format("ddd");

// //       if (weekHours[day] !== undefined) {
// //         const time = r.total_hours || "0:00:00";

// //         weekHours[day] = time.split(":").slice(0, 2).join(":");

// //         const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
// //         totalSeconds += h * 3600 + m * 60 + s;
// //       }
// //     }
// //   });


// emp.recap?.forEach((r) => {
//   const recordDate = dayjs(r.date).startOf("day");

//   const rStart = rangeStart.startOf("day");
//   const rEnd = rangeEnd.startOf("day");

//   const isInRange =
//     (recordDate.isSame(rStart) || recordDate.isAfter(rStart)) &&
//     (recordDate.isSame(rEnd) || recordDate.isBefore(rEnd));

//   if (isInRange) {
//     const day = recordDate.format("ddd");

//     if (weekHours[day] !== undefined) {
//       const time = r.total_hours || "0:00:00";

//       // current value
//       const [oldH = 0, oldM = 0] = weekHours[day]
//         .split(":")
//         .map(Number);

//       // new value
//       const [newH = 0, newM = 0, newS = 0] = time
//         .split(":")
//         .map(Number);

//       // convert to minutes
//       const oldTotalMins = oldH * 60 + oldM;
//       const newTotalMins = newH * 60 + newM;

//       const totalMins = oldTotalMins + newTotalMins;

//       // back to HH:MM
//       const finalHrs = Math.floor(totalMins / 60);
//       const finalMins = totalMins % 60;

//       weekHours[day] = `${finalHrs}:${String(finalMins).padStart(
//         2,
//         "0"
//       )}`;

//       // ✅ overall total
//       totalSeconds += newH * 3600 + newM * 60 + newS;
//     }
//   }
// });


//   // ✅ convert total seconds to HH:MM
//   const hours = Math.floor(totalSeconds / 3600);
//   const minutes = Math.floor((totalSeconds % 3600) / 60);

//   const calculatedTotal = `${hours}:${String(minutes).padStart(2, "0")}`;

//   return {
//     id: emp.emp_id,
//     name: emp.employee_name,
//     type: emp.employee_type,
//     hireDate: emp.hire_date || "N/A",

//     totalDays: emp.total_days_in_period,
//     daysAbsent: emp.days_absent,
//     pto: Number(emp.pto_days) || 0,

//     // ❌ REMOVE old monthly total
//     // totalHours: emp.total_hours_for_period

//     // ✅ USE calculated total
//     totalHours: calculatedTotal,

//     role: emp.employee_type === "Hourly" ? "Employee" : "Staff",

//     recap: emp.recap,
//     weekHours,
//   };
// });


  // setTableData(mapped);


  const mapped = data.map((emp) => {

  const weekHoursMinutes = {
    Mon: 0,
    Tue: 0,
    Wed: 0,
    Thu: 0,
    Fri: 0,
    Sat: 0,
    Sun: 0,
  };

  let totalSeconds = 0;
  const weekFlags = {};

  // ✅ Use full dateRange (start → end), not the 7-day window
  const fullStart = dayjs(dateRange.startDate).startOf("day");
  const fullEnd = dayjs(dateRange.endDate).startOf("day");

  emp.recap?.forEach((r) => {
    const recordDate = dayjs(r.date).startOf("day");

    const isInRange =
      (recordDate.isSame(fullStart, "day") || recordDate.isAfter(fullStart, "day")) &&
      (recordDate.isSame(fullEnd, "day") || recordDate.isBefore(fullEnd, "day"));

    if (isInRange) {
      const day = recordDate.format("ddd"); // "Mon", "Tue", etc.

      if (weekHoursMinutes[day] !== undefined) {
        // ✅ Accumulates ALL Mondays, ALL Tuesdays, etc.
        const sec = tableDaySeconds(r, approvedOnly);
        weekHoursMinutes[day] += Math.floor(sec / 60);
        totalSeconds += sec;
        if (approvedOnly && isUnverifiedDay(r)) weekFlags[day] = true;
      }
    }
  });

  // Convert mins → HH:MM per day
  const weekHours = {};
  Object.keys(weekHoursMinutes).forEach((day) => {
    const mins = weekHoursMinutes[day];
    const hrs = Math.floor(mins / 60);
    const remMins = mins % 60;
    weekHours[day] = `${hrs}:${String(remMins).padStart(2, "0")}`;
  });

  // Final total
  const totalHours = Math.floor(totalSeconds / 3600);
  const totalMinutes = Math.floor((totalSeconds % 3600) / 60);
  const calculatedTotal = `${totalHours}:${String(totalMinutes).padStart(2, "0")}`;

  return {
    id: emp.emp_id,
    name: emp.employee_name,
    type: emp.employee_type,
    hireDate: emp.hire_date || "N/A",
    totalDays: emp.total_days_in_period,
    daysAbsent: emp.days_absent,
    pto: Number(emp.pto_days) || 0,
    totalHours: calculatedTotal,
    role: emp.employee_type === "Hourly" ? "Employee" : "Staff",
    recap: emp.recap,
    weekHours,
    weekFlags,
    unverifiedDays: approvedOnly ? unverifiedDayCount(emp.recap) : 0,
  };
});

setTableData(mapped);
}, [data, dateRange, approvedOnly]);

// const filteredData = (tableData || []).filter((emp) =>
//   (emp?.name ?? "")
//     .trim()
//     .toLowerCase()
//     .includes((searchTerm ?? "").trim().toLowerCase())
// );

  // const totalEntries = tableData.length;
  // const totalPages = Math.ceil(totalEntries / rowsPerPage);
  // const startIndex = (currentPage - 1) * rowsPerPage;
  // const currentData = tableData.slice(startIndex, startIndex + rowsPerPage);
// const showingStart = totalEntries === 0 ? 0 : startIndex + 1;
// const showingEnd = startIndex + currentData.length;
  const handleRowClick = (emp) => setSelectedEmployee(emp);
  const handleCloseModal = () => setSelectedEmployee(null);


const [selectedDayEmployee, setSelectedDayEmployee] = useState(null);
const [selectedDay, setSelectedDay] = useState("");
  const handleDayClick = (emp, day) => {
  setSelectedDayEmployee(emp);
  setSelectedDay(day);
};

const handleCloseDayModal = () => {
  setSelectedDayEmployee(null);
  setSelectedDay("");
};

  const handlePTOChange = (id, delta) => {
    setTableData((prev) =>
      prev.map((emp) =>
        emp.id === id ? { ...emp, pto: Math.max(0, emp.pto + delta) } : emp
      )
    );
  };

  return (
    <>
     <div className="flex justify-end items-center gap-3 m-2">
        {approvedOnly && (
          <span className="text-xs text-gray-500 mt-2">
            Approved hours only. <span className="text-[#E17954]">*</span> = an automatic clock-out waiting for its correction (not counted).
          </span>
        )}
        <button
          onClick={() => setShowReportModal(true)}
          className="px-4 py-2 bg-[#50869A] mt-2 text-white rounded-md hover:bg-[#3d6a7a] transition-colors flex items-center gap-2"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
            />
          </svg>
          Generate Reports
        </button>
      </div>
      <div className="mt-6 bg-white rounded-md shadow-sm border border-gray-200">
        {/* 🔄 Loader */}
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="250px"
          >
            <CircularProgress size={45} thickness={4} color="primary" />
          </Box>
        ) : (
          <div className="overflow-x-auto ">
            <table className="w-full border-collapse table-fixed">
              <thead>
                <tr className="bg-[#50869A] text-white text-sm">
                  <th className="py-3 px-4 text-left font-medium w-[25%]">
                    Employee Name
                  </th>
                  <th className="py-3 px-4 font-medium w-[15%]">Hire Date</th>
                  <th className="py-3 px-4 font-medium w-[10%]">Total Days</th>
                  <th className="py-3 px-4 font-medium w-[10%]">Days Absent</th>
                  <th className="py-3 px-4 font-medium w-[15%] text-center">
                    PTO
                  </th>
                  <th className="py-3 px-2 w-[10%]">Mon</th>
<th className="py-3 px-2 w-[10%]">Tue</th>
<th className="py-3 px-2 w-[10%]">Wed</th>
<th className="py-3 px-2 w-[10%]">Thu</th>
<th className="py-3 px-2 w-[10%]">Fri</th>
<th className="py-3 px-2 w-[10%]">Sat</th>
<th className="py-3 px-2 w-[10%]">Sun</th>

                  <th className="py-3 px-4 font-medium w-[15%]">Total Hours</th>
                </tr>
              </thead>

              <tbody>
                {/* 🧾 Show “No data available” if empty */}
                {tableData.length === 0 ? (
                  <tr>
                    <td
                      colSpan="6"
                      className="py-6 text-center text-gray-500 text-sm"
                    >
                      No data available
                    </td>
                  </tr>
                ) : (
                  tableData.map((emp) => (
                    <tr
                      key={emp.id}
                      className="border-b border-gray-200 bg-white hover:bg-gray-100 cursor-pointer"                      
                    >
                      <td className="py-3 px-4">
                        <div className="flex items-center text-start gap-2" onClick={() => handleRowClick(emp)}>
                          <div>
                            <div className="flex items-center gap-3">
                              <div className="font-medium text-gray-900">
                                {emp.name}
                              </div>
                              {emp.type && (
                                <span className="inline-block bg-[#E17954] text-white text-xs px-3 py-0.5 rounded-full">
                                  {emp.type}
                                </span>
                              )}
                              {emp.unverifiedDays > 0 && (
                                <span className="inline-block border border-[#E17954] text-[#E17954] text-xs px-2 py-0.5 rounded-full" title={UNVERIFIED_TITLE}>
                                  {emp.unverifiedDays} awaiting correction
                                </span>
                              )}
                            </div>
                            <div className="text-sm text-gray-500">
                              {emp.role}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td className="py-3 px-4 text-gray-800 text-sm">
                        {emp.hireDate}
                      </td>
                      <td className="py-3 px-4 text-gray-800 text-sm text-center">
                        {emp.totalDays}
                      </td>
                      <td className="py-3 px-4 text-gray-800 text-sm text-center">
                        {emp.daysAbsent}
                      </td>

                      <td
                        className="py-3 px-4 text-center"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="flex justify-center items-center gap-2">
                          <button
                            onClick={() => handlePTOChange(emp.id, -1)}
                            className="px-2 py-1 border border-gray-300 rounded hover:bg-gray-100"
                          >
                            -
                          </button>
                          <span
                            className="w-4 text-sm"
                            onClick={() => setSelectedPtoEmployee(emp)}
                          >
                            {emp.pto}
                          </span>
                          <button
                            onClick={() => handlePTOChange(emp.id, 1)}
                            className="px-2 py-1 border border-gray-300 rounded hover:bg-gray-100"
                          >
                            +
                          </button>
                        </div>
                      </td>
<td className="text-center text-sm" onClick={() => handleDayClick(emp, "Monday")}>{emp.weekHours.Mon}{emp.weekFlags?.Mon && <span className="text-[#E17954]" title={UNVERIFIED_TITLE}>*</span>}</td>
<td className="text-center text-sm" onClick={() => handleDayClick(emp, "Tuesday")}>{emp.weekHours.Tue}{emp.weekFlags?.Tue && <span className="text-[#E17954]" title={UNVERIFIED_TITLE}>*</span>}</td>
<td className="text-center text-sm" onClick={() => handleDayClick(emp, "Wednesday")}>{emp.weekHours.Wed}{emp.weekFlags?.Wed && <span className="text-[#E17954]" title={UNVERIFIED_TITLE}>*</span>}</td>
<td className="text-center text-sm" onClick={() => handleDayClick(emp, "Thursday")}>{emp.weekHours.Thu}{emp.weekFlags?.Thu && <span className="text-[#E17954]" title={UNVERIFIED_TITLE}>*</span>}</td>
<td className="text-center text-sm" onClick={() => handleDayClick(emp, "Friday")}>{emp.weekHours.Fri}{emp.weekFlags?.Fri && <span className="text-[#E17954]" title={UNVERIFIED_TITLE}>*</span>}</td>
<td className="text-center text-sm" onClick={() => handleDayClick(emp, "Saturday")}>{emp.weekHours.Sat}{emp.weekFlags?.Sat && <span className="text-[#E17954]" title={UNVERIFIED_TITLE}>*</span>}</td>
<td className="text-center text-sm" onClick={() => handleDayClick(emp, "Sunday")}>{emp.weekHours.Sun}{emp.weekFlags?.Sun && <span className="text-[#E17954]" title={UNVERIFIED_TITLE}>*</span>}</td>

                      <td className="py-3 px-4 text-gray-800 text-sm text-center">
                        {emp.totalHours}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {/* 📄 Pagination */}

           {/* <div className="flex justify-between items-center p-3 text-sm text-gray-600"> */}
  
  {/* Showing entries - LEFT */}
  {/* <div>
    Showing {showingStart} - {showingEnd} of {totalEntries} entries
  </div> */}

  {/* Pagination - RIGHT */}
  {/* {totalPages > 1 && (
    <div className="flex items-center">
      <button
        onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
        disabled={currentPage === 1}
        className="px-3 py-1 border border-gray-300 rounded mx-1 hover:bg-gray-100 disabled:opacity-40"
      >
        Prev
      </button>

      <span className="px-2 py-1">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={() =>
          setCurrentPage((p) => Math.min(totalPages, p + 1))
        }
        disabled={currentPage === totalPages}
        className="px-3 py-1 border border-gray-300 rounded mx-1 hover:bg-gray-100 disabled:opacity-40"
      >
        Next
      </button>
    </div>
  )} */}
{/* </div> */}

          </div>
        )}
      </div>

      {/* 🧾 Employee Modal */}
      {selectedEmployee && (
        <EmployeeModal
          employee={selectedEmployee}
          dateRange={dateRange}
          onClose={handleCloseModal}
        />
      )}
      {selectedDayEmployee && (
        <EmployeeDayModal
          employee={selectedDayEmployee}
          selectedDay={selectedDay}
          dateRange={dateRange}
          onClose={handleCloseDayModal}
        />
      )}
  {/* Generate Report Modal */}
      {showReportModal && (
        <GenerateReportModal
          employees={tableData}
          dateRange={dateRange}
          onClose={() => setShowReportModal(false)}
        />
      )}
      {selectedPtoEmployee && (
        <PtoModal
          employee={selectedPtoEmployee}
          onClose={() => setSelectedPtoEmployee(null)}
        />
      )}
    </>
  );
};

export default RecapTable;
